import { render, staticRenderFns } from "./widget_best_sectors.vue?vue&type=template&id=133ab628&scoped=true&"
import script from "./widget_best_sectors.vue?vue&type=script&lang=js&"
export * from "./widget_best_sectors.vue?vue&type=script&lang=js&"
import style0 from "./widget_best_sectors.vue?vue&type=style&index=0&id=133ab628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133ab628",
  null
  
)

export default component.exports